import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        padding: ${theme.spacing(0, 1, 0, 0)};
        display: flex;
        text-decoration: none;
        font-weight: ${theme.typography.fontWeightBold};
        max-width: 35%;
        aspect-ratio: 1;
        overflow: hidden;
        align-items: center;
        justify-content: center;
`
);

function Logo() {
  // const { t } = useTranslation();

  return (
    <LogoWrapper to="/">
      <img
        style={{
          objectFit: 'contain',
          maxWidth: '100%',
          maxHeight: '100%',
          height: 'auto',
          width: 'auto'
        }}
        src="/static/images/logos/kingkong-logo.png"
        alt="Traxsmart logo"
      />
    </LogoWrapper>
  );
}

export default Logo;
